import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import FormRow from 'components/FormRow';
import Fieldset from 'components/Fieldset';

const MotivationForm = ({ saving, disabled, inputs, onInputChange }) => {
  const { t } = useTranslation();
  return (
    <Fieldset title={t('motivation.label')} disabled={saving || disabled}>
      <FormRow
        label={t('writeMotivation.label')}
        inputType="textarea"
        name="motivation"
        id="motivation"
        value={inputs.motivation}
        onChange={onInputChange}
        extraClasses="u-margin-bottom-none"
        className="c-input-text--large-textarea"
        required
      />
    </Fieldset>
  );
};

MotivationForm.propTypes = {
  saving: PropTypes.bool,
  disabled: PropTypes.bool,
  inputs: PropTypes.object,
  onInputChange: PropTypes.func,
};

export default MotivationForm;
